/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/14/14
 * Time: 5:46 PM
 * To change this template use File | Settings | File Templates.
 */
//ArticleContainerLayout


define(function (require) {
    "use strict";

    var CONST = require("const");
    var template = require("connection-templates/articleContainerLayout.tmpl");
    var NoData = require("ui.components/no-data/NoData");

    var ArticleContainerLayout = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        ArticleContainerLayout = Marionette.Layout.extend({
            className: 'connectionPanel-articleContainer',
            template: template,
            regions: {
                noDataRegion: ".no-data",
                expandedArticleRegion: ".expanded-article-region",
                relatedRegion: ".related-region"
            },
            ui: {
                closeButton: ".close-article",
                expandedArticle: ".expanded-article-region"
            },

            triggers: {
                "click @ui.closeButton": "articleContainerController:closeArticle"
            },

            initialize: function () {
                this.isOpen = false;
            },

            onRender: function () {
                this.$el.addClass("hide");
            },

            setArticleContainerLocation: function (isListViewOpen, isTicketViewOpen) {
                this.$el.toggleClass("ticket-list", isListViewOpen);
                this.$el.toggleClass("ticket-view", isTicketViewOpen);
            },

            toggleNoData:function(toggle){
                if(this.noData){
                    this.noData.el.toggleClass("hide", toggle);
                }
                else {
                    this._renderNoData();
                }
            },

            _renderNoData: function () {
                this.noData = new NoData({
                    el: this.$el.find(".no-data"),
                    permutation: NoData.PERMUTATION.REFRESH_LINK_MEDIUM,
                    callback: _.bind(this._onNoDataClick, this),
                    errorMessage: LE.translator.translate("LEConnection.connectionPanel.error404")
                });
                this.noData.render();
            },

            _onNoDataClick:function(){
                LEConnection.vent.trigger("nodata:click:refresh");
                LE.navigator.reload();
            },

            setOnTop: function (value) {
                this.$el.toggleClass("decrease-z-index",!value);
            },

            toggleArticlePanel: function (isOpen) {
                if (this.isOpen !== isOpen) {
                    this.isOpen = isOpen;
                    var that = this;

                    // if opening - remove prior to motion
                    if (isOpen) {
                        that.$el.removeClass("hide");
                    }

                    // queue the animation for smooth opening
                    _.delay(function () {
                        that.$el.toggleClass("article-is-opened", isOpen);
                    },100);

                    // on hide enforce display none
                    if (!isOpen) {
                        that.$el.addClass("hide");
                    }

                    $(".root .le.connection-bar-wrapper.connection-panel-wrapper .connection-panel-main-container").toggleClass("cp-shadow",!isOpen);
                }
            }
        });
    });
    return ArticleContainerLayout;
});
